window.addEventListener('load', event => {
    const autoplayVideos = document.querySelectorAll('video.autoplay-video');
    const docBody = document.body;

    const playVideo = function() {
        for (let video of autoplayVideos) {
            video.play();
        }
        docBody.removeEventListener('touchstart', playVideo);
    };

    if (window.matchMedia('(max-width:640px)').matches && autoplayVideos.length) {
        docBody.addEventListener('touchstart', playVideo);
    }

    // Handles videos that are display none and visible at 4xl breakpoints to sync playback times when page is resized above that breakpoint

    const syncVideoPlaybackThrottle = _throttle(syncVideoPlayback, 100, {leading: false, trailing: true});

    function syncVideoPlayback() {
        if (window.matchMedia('(min-width:1920px)').matches && autoplayVideos.length) {
            let mainSyncVideo = document.querySelector('video.main-video-sync');
            let syncTime = mainSyncVideo.currentTime;
            for (let video of autoplayVideos) {
                if (Math.round(video.currentTime) !== Math.round(syncTime)) {
                    video.currentTime = syncTime;
                }
            }
        }
    }
    const resizeListener = () => {
        syncVideoPlaybackThrottle();
    };

    window.addEventListener('resize', resizeListener);
});

